export default __webpack_public_path__ + "static/media/bach-prelude-piano.49aa9a6d.jpeg";